import { useQuery } from 'react-query';

import { useApi } from 'hooks/useApi';
import { Project } from 'types';

export const useProject = (id: string) => {
  const api = useApi();

  return useQuery(
    ['get-project-details', id],
    async (): Promise<Project | null> => {
      const url = `/project/${id}/`;
      const result = await api.get<Project | null>(url);

      return result;
    },
    { refetchOnWindowFocus: false },
  );
};
